// extracted by mini-css-extract-plugin
module.exports = {"primary":"_3r3Zx","list":"x1v0Y","item":"tIhEC","link":"wA6Ax","active":"iwVNP","theme_main":"I80pN","theme_footer":"Yo6Pa","color_pale":"HnpV7","simple":"dGR0q"};